import {apiRoot} from "./apiRoot.ts";
import {ActivityType} from "./surcharge.slice.ts";

export const activitySlice = apiRoot.injectEndpoints({
    endpoints: build => ({
        getActivityTypes: build.query<ActivityType[], void>({
            query: () => `/api/worktimeexpense/activity/types`
        })
    })
})

export const {useGetActivityTypesQuery} = activitySlice